import type { UserMediaEntity } from '@/domain/entities/userMedia/userMediaEntity';
import { firestoreService } from '@/data/services/firestoreService';
import { UserMediaRemapper } from '@/domain/remappers/userMedia/userMediaRemapper';

/**
 * GetUserUseMediaCase
 * 
 * Retrieves a user media by ID from Firestore.
 * Uses UserMediaRemapper to transform raw Firestore data to User Media entity.
 */
export class GetUserMediaUseCase {
    async execute(mediaId: string): Promise<UserMediaEntity | null> {
        const json = await firestoreService.getUserMedia(mediaId);

        if (!json) {
            return null;
        }

        return UserMediaRemapper.toEntity(json) as UserMediaEntity;
    }
}

export const getUserMediaUseCase = new GetUserMediaUseCase();
